import React from 'react';
import {observer} from "mobx-react";
import {UsefulLinksListComponent} from './parts/useful-links-list/useful-links-list.component';
import {CyClass} from '../../../common/cy-classes';
import {UserMenuSectionBox} from '../user-menu/user-menu/boxes/user-menu-section.box';

export const UsefulLinks: React.FC = observer(() => {
    return (
        <UserMenuSectionBox className={CyClass('cy-useful-links-section')}>
            <UsefulLinksListComponent/>
        </UserMenuSectionBox>
    );
});
